import styled from "styled-components";
import colors from "../../constants/colors";

export const GreetingContainer = styled("div")<{ $compact?: boolean }>(
  ({ $compact }) => ({
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    padding: $compact ? "1rem 1.5rem" : "1.5rem 2rem",
    direction: "rtl",
    background: colors.GLASS_WHITE,
    backdropFilter: "blur(10px)",
    borderRadius: "16px",
    border: `1px solid ${colors.GLASS_BORDER}`,
    boxShadow: `
      0px 4px 12px ${colors.SHADOW_LIGHT},
      0px 1px 3px ${colors.SHADOW_PURPLE_LIGHT}
    `,
    marginBottom: "2rem",
  }),
);

export const GreetingIcon = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "48px",
  height: "48px",
  borderRadius: "12px",
  background: colors.GRADIENT_PURPLE,
  color: colors.WHITE,
  flexShrink: 0,

  "& .MuiSvgIcon-root": {
    fontSize: "28px",
  },
});

export const TimeGreeting = styled("h2")({
  fontSize: "20px",
  fontWeight: 700,
  color: colors.BLACK,
  marginBottom: "0.25rem",
  lineHeight: 1.2,
});

export const ContextMessage = styled("p")({
  fontSize: "14px",
  lineHeight: 1.4,
  color: colors.GREY_7,
  margin: 0,
});
